var map = {
	"./Irresistible/Food Service Trend Scape/image1.png": 43289,
	"./Irresistible/Food Service Trend Scape/image2.png": 87202,
	"./Irresistible/Food Service Trend Scape/image3.png": 8331,
	"./Irresistible/Food Service Trend Scape/image4.png": 58420,
	"./Irresistible/Food Service Trend Scape/image5.png": 75101,
	"./Irresistible/Food Service Trend Scape/image6.png": 93894,
	"./Irresistible/Food Service Trend Scape/image7.png": 32911,
	"./Irresistible/Food Service Trend Scape/image8.png": 7960,
	"./Irresistible/Social Listening Analysis/image1.png": 90969,
	"./Irresistible/Social Listening Analysis/image2.png": 34882,
	"./Irresistible/Trend Deep Dive/image1.png": 24754,
	"./Irresistible/Trend Deep Dive/image2.png": 89289,
	"./Irresistible/Trend Deep Dive/image3.png": 65088,
	"./Irresistible/Trend Deep Dive/image4.png": 93119,
	"./Irresistible/irresisitblevegetables.jpg": 98051,
	"./feelgoodfood/Food Service Trend Scape/image1.png": 81861,
	"./feelgoodfood/Food Service Trend Scape/image2.png": 54030,
	"./feelgoodfood/Food Service Trend Scape/image3.png": 53527,
	"./feelgoodfood/Food Service Trend Scape/image4.png": 31384,
	"./feelgoodfood/Food Service Trend Scape/image5.png": 52513,
	"./feelgoodfood/Food Service Trend Scape/image6.png": 11434,
	"./feelgoodfood/Food Service Trend Scape/image7.png": 26995,
	"./feelgoodfood/Food Service Trend Scape/image8.png": 1076,
	"./feelgoodfood/Social Listening Analysis/image1.png": 77245,
	"./feelgoodfood/Social Listening Analysis/image2.png": 9830,
	"./feelgoodfood/Trend Deep Dive/image1.png": 78086,
	"./feelgoodfood/Trend Deep Dive/image2.png": 75645,
	"./feelgoodfood/Trend Deep Dive/image3.png": 42612,
	"./feelgoodfood/Trend Deep Dive/image4.png": 92523,
	"./feelgoodfood/feelgoodfood.jpg": 46693,
	"./flavourcontrasts/Food Service Trend Scape/image1.png": 47182,
	"./flavourcontrasts/Food Service Trend Scape/image2.png": 17541,
	"./flavourcontrasts/Food Service Trend Scape/image3.png": 34652,
	"./flavourcontrasts/Food Service Trend Scape/image4.png": 89523,
	"./flavourcontrasts/Food Service Trend Scape/image5.png": 50666,
	"./flavourcontrasts/Food Service Trend Scape/image6.png": 64897,
	"./flavourcontrasts/Food Service Trend Scape/image7.png": 43768,
	"./flavourcontrasts/Food Service Trend Scape/image8.png": 68719,
	"./flavourcontrasts/Social Listening Analysis/image1.png": 64580,
	"./flavourcontrasts/Social Listening Analysis/image2.png": 19231,
	"./flavourcontrasts/Trend Deep Dive/image1.png": 23619,
	"./flavourcontrasts/Trend Deep Dive/image2.png": 38344,
	"./flavourcontrasts/Trend Deep Dive/image3.png": 52561,
	"./flavourcontrasts/Trend Deep Dive/image4.png": 11550,
	"./flavourcontrasts/sensoryboom.jpg": 40569,
	"./joyfulsharing/Food Service Trend Scape/image1.png": 23553,
	"./joyfulsharing/Food Service Trend Scape/image2.png": 74570,
	"./joyfulsharing/Food Service Trend Scape/image3.png": 29779,
	"./joyfulsharing/Food Service Trend Scape/image4.png": 46172,
	"./joyfulsharing/Food Service Trend Scape/image5.png": 59237,
	"./joyfulsharing/Food Service Trend Scape/image6.png": 87438,
	"./joyfulsharing/Food Service Trend Scape/image7.png": 30455,
	"./joyfulsharing/Food Service Trend Scape/image8.png": 79920,
	"./joyfulsharing/Social Listening Analysis/image1.png": 84753,
	"./joyfulsharing/Social Listening Analysis/image2.png": 79994,
	"./joyfulsharing/Trend Deep Dive/image1.png": 24042,
	"./joyfulsharing/Trend Deep Dive/image2.png": 81473,
	"./joyfulsharing/Trend Deep Dive/image3.png": 43992,
	"./joyfulsharing/Trend Deep Dive/image4.png": 66135,
	"./joyfulsharing/joyfulsharing.jpg": 95957,
	"./lowwastemenus/Food Service Trend Scape/image1.png": 55736,
	"./lowwastemenus/Food Service Trend Scape/image2.png": 1491,
	"./lowwastemenus/Food Service Trend Scape/image3.png": 62634,
	"./lowwastemenus/Food Service Trend Scape/image4.png": 29509,
	"./lowwastemenus/Food Service Trend Scape/image5.png": 46620,
	"./lowwastemenus/Food Service Trend Scape/image6.png": 4727,
	"./lowwastemenus/Food Service Trend Scape/image7.png": 59150,
	"./lowwastemenus/Food Service Trend Scape/image8.png": 91065,
	"./lowwastemenus/Social Listening Analysis/image1.png": 73446,
	"./lowwastemenus/Social Listening Analysis/image2.png": 54653,
	"./lowwastemenus/Trend Deep Dive/image1.png": 6065,
	"./lowwastemenus/Trend Deep Dive/image2.png": 29818,
	"./lowwastemenus/Trend Deep Dive/image3.png": 19651,
	"./lowwastemenus/Trend Deep Dive/image4.png": 70252,
	"./lowwastemenus/lowwastemenu.jpg": 97548,
	"./mindfulprotein/Food Service Trend Scape/image1.png": 14292,
	"./mindfulprotein/Food Service Trend Scape/image2.png": 36751,
	"./mindfulprotein/Food Service Trend Scape/image3.png": 51654,
	"./mindfulprotein/Food Service Trend Scape/image4.png": 56633,
	"./mindfulprotein/Food Service Trend Scape/image5.png": 24528,
	"./mindfulprotein/Food Service Trend Scape/image6.png": 89931,
	"./mindfulprotein/Food Service Trend Scape/image7.png": 42626,
	"./mindfulprotein/Food Service Trend Scape/image8.png": 43493,
	"./mindfulprotein/Social Listening Analysis/image1.png": 45466,
	"./mindfulprotein/Social Listening Analysis/image2.png": 53777,
	"./mindfulprotein/Trend Deep Dive/image1.png": 2133,
	"./mindfulprotein/Trend Deep Dive/image2.png": 16382,
	"./mindfulprotein/Trend Deep Dive/image3.png": 68871,
	"./mindfulprotein/Trend Deep Dive/image4.png": 89256,
	"./mindfulprotein/mindfulprotein.jpg": 30215,
	"./modernizedcomfortfood/Food Service Trend Scape/image1.png": 36065,
	"./modernizedcomfortfood/Food Service Trend Scape/image2.png": 87082,
	"./modernizedcomfortfood/Food Service Trend Scape/image3.png": 37843,
	"./modernizedcomfortfood/Food Service Trend Scape/image4.png": 54236,
	"./modernizedcomfortfood/Food Service Trend Scape/image5.png": 71749,
	"./modernizedcomfortfood/Food Service Trend Scape/image6.png": 52974,
	"./modernizedcomfortfood/Food Service Trend Scape/image7.png": 42967,
	"./modernizedcomfortfood/Food Service Trend Scape/image8.png": 69136,
	"./modernizedcomfortfood/Social Listening Analysis/image1.png": 68401,
	"./modernizedcomfortfood/Social Listening Analysis/image2.png": 60090,
	"./modernizedcomfortfood/Trend Deep Dive/image1.png": 95242,
	"./modernizedcomfortfood/Trend Deep Dive/image2.png": 9473,
	"./modernizedcomfortfood/Trend Deep Dive/image3.png": 88344,
	"./modernizedcomfortfood/Trend Deep Dive/image4.png": 37335,
	"./modernizedcomfortfood/modernizedcomfortfood.jpg": 84645,
	"./wildandpure/Food Service Trend Scape/image1.png": 76229,
	"./wildandpure/Food Service Trend Scape/image2.png": 64750,
	"./wildandpure/Food Service Trend Scape/image3.png": 47895,
	"./wildandpure/Food Service Trend Scape/image4.png": 42104,
	"./wildandpure/Food Service Trend Scape/image5.png": 63233,
	"./wildandpure/Food Service Trend Scape/image6.png": 5802,
	"./wildandpure/Food Service Trend Scape/image7.png": 37715,
	"./wildandpure/Food Service Trend Scape/image8.png": 95444,
	"./wildandpure/Social Listening Analysis/image1.png": 36445,
	"./wildandpure/Social Listening Analysis/image2.png": 69030,
	"./wildandpure/Trend Deep Dive/image1.png": 75110,
	"./wildandpure/Trend Deep Dive/image2.png": 56317,
	"./wildandpure/Trend Deep Dive/image3.png": 39636,
	"./wildandpure/Trend Deep Dive/image4.png": 89547,
	"./wildandpure/wildandpure.jpg": 9525
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 23057;
module.exports = webpackAsyncContext;